import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Colors } from "../Constant/Color";
import { useSelector } from "react-redux";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { paymentMethod } from "../Redux/LoginReduces";
import DownloadIcon from "@mui/icons-material/Download";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import {
  Document,
  Page,
  Text,
  View,
  PDFViewer,
  PDFDownloadLink,
  Image,
  Font,
} from "@react-pdf/renderer";
//import MyFontRegular from "/fonts/Poppins-Medium.ttf";
//import MyFontBold from "/fonts/Poppins-Medium.ttf";
import { Base_Uri, Image_Uri } from "../Constant/BaseUri";
import axios from "axios";
import CustomButton from "./Button";
import { RingLoader } from "react-spinners";
import { message } from "antd";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "80vh",
  overflow: "auto",
  width: { lg: "70%", md: "90%", sm: "90%", xs: "100%" },
  borderRadius: "10px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

function TransactionDetailsModal({
  ledgerData,
  containerStyle,
  open,
  closeModal,
  buttonContainerStyle,
  buttonStyle,
  buttonStyle2,
  confirm,
  specialTextStyle,
  buttonText,
  specialText,
  showDiscount,
}) {
  const [selectVersion, setSelectVersion] = React.useState("lts");
  const [imagePath, setImagePath] = React.useState("");
  let [otherDetails, setOtherDetails] = React.useState({ ...ledgerData });
  // let otherDetails = { ...ledgerData }
  const [selectedInvoice, setSelectedInvoice] = React.useState({});
  React.useEffect(() => {
    setOtherDetails({ ...ledgerData });
  }, [ledgerData]);
  React.useEffect(() => {
    if (ledgerData?.isEdit) {
      //console.log(ledgerData?.isEdit, "ledgerData?.isEdit");

      axios
        .get(
          `${Base_Uri}getInvoicesWithFilter?invoiceNumber=${ledgerData?.invoiceNumber}`
        )
        .then((res) => {
          const invoice = res?.data?.data?.[0];
          if (invoice) {
            setSelectedInvoice(invoice);
            //console.log(invoice, "Fetched invoice");
          }
        })
        .catch((err) => console.error("Error fetching invoice:", err));
    }
  }, [ledgerData]); // <--- add ledgerData as dependency

  React.useEffect(() => {
    if (!ledgerData?.isEdit) return;
    if (!selectedInvoice) return;
    if (typeof selectedInvoice !== "object") return;
    if (Object.keys(selectedInvoice).length === 0) return;

    const func = async () => {
      if (selectVersion === "lts") {
        if (ledgerData && typeof ledgerData === "object") {
          setOtherDetails({ ...ledgerData });
        } else {
          console.warn("ledgerData not ready yet");
        }
      } else {
        const versionIndex = Number(selectVersion) - 1;
        const versionData = selectedInvoice?.history?.[versionIndex];

        if (versionData && typeof versionData === "object") {
          setOtherDetails({
            ...versionData,
            customerDetails: ledgerData?.customerDetails,
            employeeDetails: versionData?.employeeDetails?.[0],
            date: versionData?.saleDate,
          });
          // console.log(
          //   { ...versionData, customerDetails: ledgerData?.customerDetails },
          //   "lo"
          // );
        } else {
          console.warn(
            "Version data not found or invalid at index:",
            versionIndex
          );
        }
      }
    };

    func();
  }, [selectVersion, selectedInvoice, ledgerData]);

  Font.register({
          family: 'MyFont',
          fonts: [
              { src: "/fonts/Poppins-Bold.ttf", fontWeight: 'bold' },
              { src: "/fonts/Poppins-Medium.ttf", fontWeight: 'normal' },
          ]
      });

  const vat = useSelector((state) => state.loginReducer.vat);
  const [pdfDownloadView, setPdfDownloadView] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const userData = useSelector((state) => state.loginReducer.updatedState);

  otherDetails.productDetails = otherDetails?.productDetails?.map((e, i) => {
    return {
      ...e,
      rate:
        otherDetails?.customerDetails?.priceLevel[0]?.id == 1
          ? e.trade_price
          : otherDetails?.customerDetails?.priceLevel[0]?.id == 2
          ? e?.warehouse_price
          : otherDetails?.customerDetails?.priceLevel[0]?.id == 4
          ? e?.diamond
          : e?.retail_price,
    };
  });

  otherDetails.returnProductDetails = otherDetails?.returnProductDetails?.map(
    (e, i) => {
      return {
        ...e,
        rate:
          otherDetails?.customerDetails?.priceLevel[0]?.id == 1
            ? e.trade_price
            : otherDetails?.customerDetails?.priceLevel[0]?.id == 2
            ? e?.warehouse_price
            : otherDetails?.customerDetails?.priceLevel[0]?.id == 4
            ? e?.diamond
            : e?.retail_price,
      };
    }
  );

  const handleOpenPdf = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    try {
      let response = await axios.get(
        `${Base_Uri}getsingleinvoice/${otherDetails?.invoiceNumber}/${otherDetails?.invoiceType}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        }
      );

      let data = response?.data;

      if (data?.status) {
        otherDetails.barcodeImagePath = data?.data?.barcodeImagePath;

        setImagePath(data?.data?.barcodeImagePath);
        setPdfDownloadView(true);

        return;
      }

      setPdfDownloadView(true);
    } catch (err) {
      setPdfDownloadView(true);
    }
  };
  //console.log(otherDetails, "l");
  const emailInvoice = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    try {
      let response = await axios.get(
        `${Base_Uri}getsingleinvoice/${otherDetails?.invoiceNumber}/${otherDetails?.invoiceType}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        }
      );

      let data = response?.data;

      if (data?.status) {
        let invoice = data.data;

        let dataToSend = {
          printInvoiceData: invoice,
        };

        setLoading(true);

        axios
          .post(`${Base_Uri}pdfSendToCustomer`, dataToSend, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            let data = res.data;

            setLoading(false);

            if (data && data.status) {
              message.info("Invoice Send Succesfully");
            }
          })
          .catch((error) => {
            //console.log(error, "errorrrr");
            setLoading(false);
            message.info("There is a server error in email sending");
          });

        return;
      }
    } catch (err) {
      message.info("Internal Server Error");
      setLoading(false);
    }
  };
  // //console.log(Number(((otherDetails?.total - (otherDetails?.discount || 0)) - otherDetails?.productDetails?.reduce((e,i)=>e+i?.cost_price,0))-(otherDetails?.SDAmount||0)),"lop")
//console.log(otherDetails?.vatAmount,"vatAmount")
  const Header = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            {otherDetails?.vatAmount && (
              <View>
                <View>
                  <Image
                    style={{ height: 50, borderRadius: 10 }}
                    source={{
                      uri: `${Image_Uri}companyImage/${vat?.companyLogo}`,
                    }}
                  />

                  <Text
                    style={{
                      color: "black",
                      fontSize: "14px",
                      marginTop: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {vat?.companyName}
                  </Text>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    {vat?.companyAddress}
                  </Text>

                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    {vat?.city}
                  </Text>

                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    {vat?.postCode}
                  </Text>
                </View>
                <View>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      marginTop: "3px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    Tel: {vat?.mobileNumber}
                  </Text>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    Email: {vat?.companyEmail}
                  </Text>
                </View>
                <View>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    VAT No: {vat?.vatNumber}
                  </Text>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    Company No: {vat?.companyNumber}
                  </Text>
                </View>
              </View>
            )}
          </View>

          <View>
            <View style={{ alignItems: "center" }}>
              <Image
                src={`${Image_Uri}products/${imagePath}`}
                style={{
                  height: "35px",
                  width: "150px",
                }}
              />
            </View>
            <View style={{ alignItems: "center", marginTop: "10px" }}>
              <Text
                style={{
                  color: "black",
                  fontSize: "16px",
                  fontFamily: "MyFont",
                  // marginTop:"10px",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {otherDetails?.vatAmount ? "Invoice" : "Quotation"}
              </Text>
            </View>

            <View>
              {otherDetails?.vatAmount && (
                <Text
                  style={{
                    color: "black",
                    fontSize: "10px",
                    fontFamily: "MyFont",
                    marginTop: "10px",
                    fontWeight: "normal",
                    textAlign: "center",
                  }}
                >
                  Invoice no: {otherDetails?.invoiceNumber}
                </Text>
              )}

              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  // marginTop:"10px",
                  fontWeight: "normal",
                  textAlign: "center",
                }}
              >
                Date:{" "}
                {new Date(otherDetails?.date).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </Text>

              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  fontWeight: "normal",
                  textAlign: "center",
                }}
              >
                Time: {new Date(otherDetails?.date).toLocaleTimeString()}
              </Text>

              {otherDetails?.vatAmount &&
                otherDetails?.returnInvoiceRef &&
                otherDetails?.returnInvoiceRef?.length > 0 && (
                  <View style={{ marginTop: "10px" }}>
                    <Text
                      style={{
                        color: "black",
                        fontSize: "10px",
                        fontFamily: "MyFont",
                        // marginTop:"10px",
                        fontWeight: "normal",
                        textAlign: "center",
                      }}
                    >
                      Return Inv Ref.:
                      {otherDetails?.returnInvoiceRef?.map((e, i) => {
                        return (
                          <Text
                            style={{
                              color: "black",
                              fontSize: "8px",
                              fontFamily: "MyFont",
                              // marginTop:"10px",
                              fontWeight: "normal",
                              textAlign: "center",
                            }}
                          >
                            {e},
                          </Text>
                        );
                      })}
                    </Text>
                  </View>
                )}

              <View style={{ marginTop: "10px" }}>
                <Text
                  style={{
                    color: "black",
                    fontSize: "12px",
                    fontFamily: "MyFont",
                    // marginTop:"10px",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {Array.isArray(otherDetails?.paymentMethod)
                    ? otherDetails?.paymentMethod
                        .map((e) =>
                          e?.toLowerCase() === "cash"
                            ? "C"
                            : e?.toLowerCase() === "card"
                            ? "CA"
                            : e?.toLowerCase() === "on account"
                            ? "A"
                            : e?.toLowerCase() === "online"
                            ? "B"
                            : e?.toLowerCase() === "exchange"
                            ? "E"
                            : e?.toUpperCase()
                        )
                        .join(", ")
                    : otherDetails?.status === "Return"
                    ? "R"
                    : ""}
                </Text>

                <Text
                  style={{
                    color: "black",
                    fontSize: "10px",
                    fontFamily: "MyFont",
                    fontWeight: "normal",
                    textAlign: "center",
                  }}
                >
                  Account No: {otherDetails?.customerDetails?.accountNo}
                </Text>

                {otherDetails?.vatAmount && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Business Name: {otherDetails?.customerDetails?.businessName}
                  </Text>
                )}

                {otherDetails?.vatAmount && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      // marginTop:"10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Email: {otherDetails?.customerDetails?.email}
                  </Text>
                )}

                {otherDetails?.vatAmount && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      marginTop: "10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Payment Method:{" "}
                    {otherDetails?.invoiceNumber?.split("_")?.[0] == "E"
                      ? "Extra Cash Paid"
                      : Array?.isArray(otherDetails?.paymentMethod)
                      ? otherDetails?.paymentMethod?.map((e, i) => e).join(",")
                      : otherDetails?.paymentMethod}
                  </Text>
                )}

                {otherDetails?.vatAmount && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      marginTop: "10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Status: {otherDetails?.status}
                  </Text>
                )}

                {/* {otherDetails?.creditDays && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      marginTop: "10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Credit Days: {otherDetails?.creditDays}
                  </Text>
                )} */}

                {/* {otherDetails?.referenceId && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      // marginTop: "10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Reference Id: {otherDetails?.referenceId}
                  </Text>
                )} */}

                {otherDetails?.transactionId && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      // marginTop: "10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Transaction Id: {otherDetails?.transactionId}
                  </Text>
                )}

                {otherDetails?.vatAmount &&
                  Array?.isArray(otherDetails?.paymentMethod) &&
                  otherDetails?.paymentMethod?.some(
                    (e) => e?.toLowerCase() == "cheque"
                  ) && (
                    <View>
                      <Text
                        style={{
                          color: "black",
                          fontSize: "10px",
                          fontFamily: "MyFont",
                          // marginTop:"10px",
                          fontWeight: "normal",
                          textAlign: "center",
                        }}
                      >
                        Cheque No: {otherDetails?.cheque_no}
                      </Text>

                      <Text
                        style={{
                          color: "black",
                          fontSize: "10px",
                          fontFamily: "MyFont",
                          // marginTop:"10px",
                          fontWeight: "normal",
                          textAlign: "center",
                        }}
                      >
                        Bank Name: {otherDetails?.bank_name}
                      </Text>

                      <Text
                        style={{
                          color: "black",
                          fontSize: "10px",
                          fontFamily: "MyFont",
                          // marginTop:"10px",
                          fontWeight: "normal",
                          textAlign: "center",
                        }}
                      >
                        Cheque Date:{" "}
                        {new Date(otherDetails.clear_date).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }
                        )}
                      </Text>
                    </View>
                  )}
              </View>
            </View>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          {/* <View style={{ flex: 0.5 }}>
                <Text
                  style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
                >
                  Item
                </Text>
              </View> */}

          {/* <View style={{ flex: 1 }}>
                <Text
                  style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
                >
                  Barcode
                </Text>
              </View> */}

          <View style={{ flex: 0.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Item
            </Text>
          </View>

          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Barcode
            </Text>
          </View>

          <View style={{ flex: 5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Product Description
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Qty
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Price
            </Text>
          </View>
          {showDiscount &&
            !(
              otherDetails?.transactionType?.toLowerCase() ==
                "return invoice" ||
              otherDetails?.transactionType?.toLowerCase() == "return quotation"
            ) && (
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  Disc
                </Text>
              </View>
            )}
          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Amount
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const MyDocument = () => (
    <Document size="A4">
      {/* <Header /> */}

      <Page style={{ padding: "0px 10px" }}>
        <Header />
        {/* Data Rows */}
        <View>
          {otherDetails &&
            otherDetails?.productDetails &&
            otherDetails?.productDetails?.length > 0 &&
            otherDetails?.productDetails?.map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderBottomWidth: 1,
                  borderColor: "#000",
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  padding: "3px 10px",
                }}
              >
                <View style={{ flex: 0.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {index + 1}
                  </Text>
                </View>

                <View style={{ flex: 1.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item.barcode}
                  </Text>
                </View>

                <View style={{ flex: 5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item.productName}
                  </Text>
                  {typeof item?.IMEI == "object" ? (
                    <View>
                      {item?.IMEI?.map((it, ind) => {
                        return (
                          <View>
                            <Text
                              style={{
                                fontFamily: "MyFont",
                                fontSize: 8,
                              }}
                            >
                              {it}
                            </Text>
                          </View>
                        );
                      })}
                    </View>
                  ) : (
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      {item?.IMEI}
                    </Text>
                  )}
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {(otherDetails?.transactionType?.toLowerCase() ==
                      "return invoice" ||
                      otherDetails?.transactionType?.toLowerCase() ==
                        "return quotation") &&
                      "-"}{" "}
                    {item?.DamageQty ? item?.DamageQty : item?.saleQty}
                  </Text>
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    £
                    {(otherDetails?.transactionType?.toLowerCase() ==
                      "return invoice" ||
                      otherDetails?.transactionType?.toLowerCase() ==
                        "return quotation") &&
                      "-"}
                    {showDiscount
                      ? item?.discountPrice >
                        (otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                          ? item?.trade_price
                          : otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            2
                          ? item?.warehouse_price
                          : item?.retail_price)
                        ? item?.discountPrice
                        : otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                        ? Number(item.trade_price).toFixed(2)
                        : otherDetails?.customerDetails?.priceLevel[0]?.id == 2
                        ? Number(item.warehouse_price).toFixed(2)
                        : Number(item.retail_price).toFixed(2)
                      : item.discountPrice
                      ? Number(item.discountPrice).toFixed(2)
                      : Number(
                          otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                            ? item.trade_price
                            : otherDetails?.customerDetails?.priceLevel[0]
                                ?.id == 2
                            ? item.warehouse_price
                            : item.retail_price
                        ).toFixed(2)}
                  </Text>
                </View>

                {showDiscount &&
                  !(
                    otherDetails?.transactionType?.toLowerCase() ==
                      "return invoice" ||
                    otherDetails?.transactionType?.toLowerCase() ==
                      "return quotation"
                  ) && (
                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        £
                        {(otherDetails?.transactionType?.toLowerCase() ==
                          "return invoice" ||
                          otherDetails?.transactionType?.toLowerCase() ==
                            "return quotation") &&
                          "-"}
                        {item.discountPrice <
                        (otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                          ? item?.trade_price
                          : otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            2
                          ? item?.warehouse_price
                          : item?.retail_price)
                          ? Number(
                              (otherDetails?.customerDetails?.priceLevel[0]
                                ?.id == 1
                                ? item.trade_price
                                : otherDetails?.customerDetails?.priceLevel[0]
                                    ?.id == 2
                                ? item.warehouse_price
                                : item.retail_price) - item.discountPrice
                            ).toFixed(2)
                          : 0}
                      </Text>
                    </View>
                  )}

                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 8,
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    £
                    {(otherDetails?.transactionType?.toLowerCase() ==
                      "return invoice" ||
                      otherDetails?.transactionType?.toLowerCase() ==
                        "return quotation") &&
                      "-"}{" "}
                    {item.discountPrice
                      ? Number(item.discountPrice * item.saleQty).toFixed(2)
                      : Number(
                          (otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                            ? item.trade_price
                            : otherDetails?.customerDetails?.priceLevel[0]
                                ?.id == 2
                            ? item.warehouse_price
                            : item.retail_price) *
                            (item?.DamageQty ? item?.DamageQty : item?.saleQty)
                        ).toFixed(2)}
                  </Text>
                </View>
              </View>
            ))}

          {/* {(otherDetails?.returnProductDetails)?((otherDetails?.SDAmount||otherDetails?.vatAmount) ?<></>:(otherDetails &&
            otherDetails?.returnProductDetails &&
            otherDetails?.returnProductDetails?.length > 0 &&
            otherDetails?.returnProductDetails?.map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderBottomWidth: 1,
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderColor: "#000",
                  padding: "3px 10px",
                }}
              >
                <View style={{ flex: 0.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {otherDetails?.productDetails?.length + (index + 1)}
                  </Text>
                </View>

                <View style={{ flex: 1.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item.barcode}
                  </Text>
                </View>

                <View style={{ flex: 5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item.productName}
                  </Text>
                  {typeof item?.IMEI == "object" ? (
                    <View>
                      {item?.IMEI?.map((it, ind) => {
                        return (
                          <View>
                            <Text
                              style={{
                                fontFamily: "MyFont",
                                fontSize: 8,
                              }}
                            >
                              {it}
                            </Text>
                          </View>
                        );
                      })}
                    </View>
                  ) : (
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      {item?.IMEI}
                    </Text>
                  )}
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    -{item?.DamageQty ? item?.DamageQty : item?.saleQty}
                  </Text>
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    £ -
                    {showDiscount
                      ? otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                        ? Number(item.trade_price).toFixed(2)
                        : otherDetails?.customerDetails?.priceLevel[0]?.id == 2
                        ? Number(item.warehouse_price).toFixed(2)
                        : Number(item.retail_price).toFixed(2)
                      : item.discountPrice
                      ? Number(item.discountPrice).toFixed(2)
                      : Number(
                          otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                            ? item.trade_price
                            : otherDetails?.customerDetails?.priceLevel[0]
                                ?.id == 2
                            ? item.warehouse_price
                            : item.retail_price
                        ).toFixed(2)}
                  </Text>
                </View>

                {showDiscount && (
                  <View style={{ flex: 1 }}>
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      £
                      {item.discountPrice
                        ? Number(
                            (otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            1
                              ? item.trade_price
                              : otherDetails?.customerDetails?.priceLevel[0]
                                  ?.id == 2
                              ? item.warehouse_price
                              : item.retail_price) - item.discountPrice
                          ).toFixed(2)
                        : 0}
                    </Text>
                  </View>
                )}
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 8,
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    £-
                    {item.discountPrice
                      ? Number(
                          item.discountPrice *
                            (item?.DamageQty ? item?.DamageQty : item.saleQty)
                        ).toFixed(2)
                      : Number(
                          (otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                            ? item.trade_price
                            : otherDetails?.customerDetails?.priceLevel[0]
                                ?.id == 2
                            ? item.warehouse_price
                            : item.retail_price) *
                            (item?.DamageQty ? item?.DamageQty : item.saleQty)
                        ).toFixed(2)}
                  </Text>
                </View>
              </View>
            )))):<></>} */}

          <View
            // key={index}
            style={{
              flexDirection: "row",
              // borderWidth: 1,
              borderColor: "#000",
              padding: "5px 10px",
              borderLeftWidth: 1,
              borderRightWidth: 1,
            }}
          >
            {/* <View style={{ flex: 0.5, }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {otherDetails?.transactionType?.toLowerCase() == "return invoice" || otherDetails?.transactionType?.toLowerCase() == "return quotation"  && "-"}{otherDetails?.totalItems}
                  </Text>
                </View> */}

            <View
              style={{ flex: showDiscount ? 7 : 7.5, alignItems: "center" }}
            >
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,

                  fontWeight: "bold",
                }}
              >
                {otherDetails?.returnProductDetails?.length != 0 ? "Sale " : ""}{" "}
                Subtotal
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 9,
                  fontWeight: "bold",
                }}
              >
                {(otherDetails?.transactionType?.toLowerCase() ==
                  "return invoice" ||
                  otherDetails?.transactionType?.toLowerCase() ==
                    "return quotation") &&
                  "-"}
                {otherDetails?.productDetails &&
                  otherDetails?.productDetails.reduce((a, b) => {
                    return otherDetails?.transactionType?.toLowerCase() ==
                      "return invoice" ||
                      otherDetails?.transactionType?.toLowerCase() ==
                        "return quotation"
                      ? b?.DamageQty
                        ? a + b?.DamageQty
                        : a + b?.saleQty
                      : a + b?.saleQty;
                  }, 0)}
              </Text>
            </View>

            <View style={{ flex: 1 }}>price</View>

            {showDiscount &&
              !(
                otherDetails?.transactionType?.toLowerCase() ==
                  "return invoice" ||
                otherDetails?.transactionType?.toLowerCase() ==
                  "return quotation"
              ) && (
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 9,
                      fontWeight: "bold",
                    }}
                  >
                    £{Number(otherDetails?.discount).toFixed(2)}
                  </Text>
                </View>
              )}

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 9,
                  fontWeight: "bold",
                }}
              >
                £{" "}
                {(otherDetails?.transactionType?.toLowerCase() ==
                  "return invoice" ||
                  otherDetails?.transactionType?.toLowerCase() ==
                    "return quotation") &&
                  "-"}
                {Number(otherDetails?.total - otherDetails?.discount).toFixed(
                  2
                )}
              </Text>
            </View>
          </View>
          {otherDetails?.SDAmount && (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 10, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  Special Discount{" "}
                  {(
                    (otherDetails?.SDAmount /
                      (otherDetails?.total -
                        // +
                        // (otherDetails?.vatAmount || 0)
                        (otherDetails?.discount || 0))) *
                    100
                  ).toFixed(2)}
                  %
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  - £ {otherDetails?.saleReturnDate && "-"}
                  {Number(otherDetails?.SDAmount).toFixed(2)}
                  {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                </Text>
              </View>
            </View>
          )}
          {otherDetails?.vatAmount && otherDetails?.SDAmount && (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 9, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  Subtotal
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,

                    fontWeight: "bold",
                  }}
                >
                  £
                  {(
                    Number(otherDetails?.total) -
                    Number(otherDetails?.discount) -
                    Number(otherDetails?.SDAmount)
                  ).toFixed(2)}
                </Text>
              </View>
            </View>
          )}
          {otherDetails?.vatAmount && (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 10, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  Vat
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,

                    fontWeight: "bold",
                  }}
                >
                  £{" "}
                  {(otherDetails?.transactionType?.toLowerCase() ==
                    "return invoice" ||
                    otherDetails?.transactionType?.toLowerCase() ==
                      "return quotation") &&
                    "-"}
                  {Number(otherDetails?.vatAmount).toFixed(2)}
                </Text>
              </View>
            </View>
          )}
          {(otherDetails?.returnProductDetails&&(otherDetails?.vatAmount||otherDetails?.SDAmount)) ? (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 10, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  Total
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,

                    fontWeight: "bold",
                  }}
                >
                £{(Number(otherDetails.vatAmount||0)+(Number((otherDetails.total||0) - (otherDetails?.discount || 0)))-Number(otherDetails?.SDAmount||0)).toFixed(2)}

                </Text>
              </View>
            </View>
          ):""}

          {(otherDetails?.returnProductDetails)&&otherDetails?.returnProductDetails?.length != 0 && (
            <>
            {(otherDetails &&
            otherDetails?.returnProductDetails &&
            otherDetails?.returnProductDetails?.length > 0 &&
            otherDetails?.returnProductDetails?.map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderTopWidth: 1,
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderColor: "#000",
                  padding: "3px 10px",
                }}
              >
                <View style={{ flex: 0.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {otherDetails?.productDetails?.length + (index + 1)}
                  </Text>
                </View>

                <View style={{ flex: 1.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item.barcode}
                  </Text>
                </View>

                <View style={{ flex: 5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item.productName}
                  </Text>
                  {typeof item?.IMEI == "object" ? (
                    <View>
                      {item?.IMEI?.map((it, ind) => {
                        return (
                          <View>
                            <Text
                              style={{
                                fontFamily: "MyFont",
                                fontSize: 8,
                              }}
                            >
                              {it}
                            </Text>
                          </View>
                        );
                      })}
                    </View>
                  ) : (
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      {item?.IMEI}
                    </Text>
                  )}
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    -{item?.DamageQty ? item?.DamageQty : item?.saleQty}
                  </Text>
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    £ -
                    {showDiscount
                      ? otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                        ? Number(item.trade_price).toFixed(2)
                        : otherDetails?.customerDetails?.priceLevel[0]?.id == 2
                        ? Number(item.warehouse_price).toFixed(2)
                        : Number(item.retail_price).toFixed(2)
                      : item.discountPrice
                      ? Number(item.discountPrice).toFixed(2)
                      : Number(
                          otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                            ? item.trade_price
                            : otherDetails?.customerDetails?.priceLevel[0]
                                ?.id == 2
                            ? item.warehouse_price
                            : item.retail_price
                        ).toFixed(2)}
                  </Text>
                </View>

                {showDiscount && (
                  <View style={{ flex: 1 }}>
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      £
                      {item.discountPrice
                        ? Number(
                            (otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            1
                              ? item.trade_price
                              : otherDetails?.customerDetails?.priceLevel[0]
                                  ?.id == 2
                              ? item.warehouse_price
                              : item.retail_price) - item.discountPrice
                          ).toFixed(2)
                        : 0}
                    </Text>
                  </View>
                )}
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 8,
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    £-
                    {item.discountPrice
                      ? Number(
                          item.discountPrice *
                            (item?.DamageQty ? item?.DamageQty : item.saleQty)
                        ).toFixed(2)
                      : Number(
                          (otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                            ? item.trade_price
                            : otherDetails?.customerDetails?.priceLevel[0]
                                ?.id == 2
                            ? item.warehouse_price
                            : item.retail_price) *
                            (item?.DamageQty ? item?.DamageQty : item.saleQty)
                        ).toFixed(2)}
                  </Text>
                </View>
              </View>
            )))}
            {otherDetails?.returnSd && (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 10, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  Special Discount
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  - £
                  {Number(otherDetails?.returnSd).toFixed(2)}
                  {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                </Text>
              </View>
            </View>
          )}
             {otherDetails?.returnVat && (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 10, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  Vat
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,

                    fontWeight: "bold",
                  }}
                >
                  -£
                  {Number(otherDetails?.returnVat).toFixed(2)}
                </Text>
              </View>
            </View>
          )}
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderColor: "#000",
                borderWidth: 1,
                padding: "5px 10px",
                // borderBottomWidth:1,
                // backgroundColor: "#DDD",
                // opacity: 0.7,
              }}
            >
              <View style={{ flex: 9, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    color: "black",
                    fontWeight: "bold",
                  }}
                >
                  Return Subtotal
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  -£
                  {otherDetails?.returnProductDetails?.length != 0
                    ? (otherDetails?.returnProductDetails?.reduce(
                        (a, b) =>
                          a + Number(b.rate) * (b?.DamageQty || b?.saleQty),
                        0
                      ) -
                      (otherDetails?.returnSd || 0) +
                      (otherDetails?.returnVat || 0)).toFixed(2)
                    : 0}{" "}
                </Text>
              </View>
            </View>
            </>
          )}

          <View
            // key={index}
            style={{
              flexDirection: "row",
              // borderWidth: 1,
              borderColor: "#000",
              borderWidth: 1,
              padding: "5px 10px",
              // borderBottomWidth:1,
              backgroundColor: "#DDD",
              opacity: 0.7,
            }}
          >
            <View style={{ flex: 10, alignItems: "center" }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                Grand Total
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 9,
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                £{" "}
                {(otherDetails?.transactionType?.toLowerCase() ==
                  "return invoice" ||
                  otherDetails?.transactionType?.toLowerCase() ==
                    "return quotation" ||
                  otherDetails?.invoiceNumber?.split("_")?.[0] == "E") &&
                  "-"}
                {otherDetails?.invoiceNumber?.split("_")?.[0] == "E"
                  ? Number(otherDetails?.total).toFixed(2)
                  : Number(otherDetails?.subtotal).toFixed(2)}
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
  // console.log(
  //   (otherDetails?.productDetails || []).reduce(
  //     (e, i) =>
  //       e +
  //       (i?.rate *
  //         ((i?.DamageQty ? i?.DamageQty : i?.returnQty) || i?.saleQty) -
  //         i?.cost_price *
  //           ((i?.DamageQty ? i?.DamageQty : i?.returnQty) || i?.saleQty) || 0),
  //     0
  //   ) - (otherDetails?.SDAmount || 0),
  //   "1234"
  // );
  //console.log(otherDetails, "otherDetails");
  return (
    <div>
      <Modal
        open={open}
        // onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {pdfDownloadView ? (
          <Box
            style={{
              wodth: "100%",
              height: "100%",
              // border: "1px solid red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <PDFViewer width={850} height={700} style={{ marginTop: 20 }}>
              <MyDocument />
            </PDFViewer>
            <CloseOutlinedIcon
              fontSize="large"
              style={{
                color: Colors.black,
                marginTop: "20px",
                cursor: "pointer",
              }}
              onClick={() => setPdfDownloadView(false)}
            />
          </Box>
        ) : (
          <>
            <Box sx={[style, { containerStyle }]}>
              {(() => {
                const canShow =
                  selectedInvoice &&
                  typeof selectedInvoice === "object" &&
                  Object.keys(selectedInvoice || {}).length > 0 &&
                  Array.isArray(selectedInvoice?.history);

                if (!canShow) return null;

                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      marginBottom: 10,
                    }}
                  >
                    {selectedInvoice?.history &&
                      selectedInvoice?.history?.map((e, ind) => (
                        <div
                          key={ind}
                          onClick={() => setSelectVersion(ind + 1)}
                          style={{
                            backgroundColor:
                              selectVersion === ind + 1
                                ? Colors.button
                                : "#e6e6e6",
                            padding: "2px 10px",
                            borderRadius: 10,
                            cursor: "pointer",
                            color:
                              selectVersion === ind + 1 ? "white" : "black",
                          }}
                        >
                          V{ind + 1}
                        </div>
                      ))}
                    <div
                      onClick={() => setSelectVersion("lts")}
                      style={{
                        backgroundColor:
                          selectVersion === "lts" ? Colors.button : "#e6e6e6",
                        cursor: "pointer",
                        padding: "2px 10px",
                        borderRadius: 10,
                        color: selectVersion === "lts" ? "white" : "black",
                      }}
                    >
                      LTS
                    </div>
                  </div>
                );
              })()}
              <View>
            {otherDetails.vatAmount ? <Grid xs={12} sm={12} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }} >

              <Typography sx={{ fontFamily: "Poppins", fontWeight: "bold", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {vat?.companyName}
              </Typography>
              <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {vat?.companyAddress}
              </Typography>

              <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {vat?.mobileNumber}
              </Typography>

              <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {vat?.companyEmail}
              </Typography>


              {otherDetails?.vatAmount && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Vat Number : {vat?.vatNumber}

              </Typography>}


              {otherDetails?.vatAmount && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Company Number : {vat?.companyNumber}

              </Typography>}



            </Grid> : ""}
          </View>
              <div xs={12} container>
                <Button
                  onClick={() => handleOpenPdf()}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    // marginLeft: "10px",
                    width: "95%",
                    marginTop: "10px",
                    backgroundColor: Colors.white,
                  }}
                >
                  <DownloadIcon />
                </Button>

                <Grid xs={8} sm={6}>
                  {otherDetails.customerDetails &&
                    otherDetails?.customerDetails?.accountNo && (
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: { xs: "10px", sm: "12px", md: "14px" },
                          textAlign: "left",
                        }}
                      >
                        Account Number:{" "}
                        {otherDetails?.customerDetails?.accountNo}
                      </Typography>
                    )}

                  {otherDetails.customerDetails &&
                    otherDetails?.customerDetails?.businessName && (
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: { xs: "10px", sm: "12px", md: "14px" },
                          textAlign: "left",
                        }}
                      >
                        Business Name:{" "}
                        {otherDetails?.customerDetails?.businessName}
                      </Typography>
                    )}

                  {otherDetails?.customerDetails &&
                    otherDetails?.customerDetails?.email && (
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: { xs: "10px", sm: "12px", md: "14px" },
                          textAlign: "left",
                        }}
                      >
                        Customer Email: {otherDetails?.customerDetails?.email}
                      </Typography>
                    )}
                </Grid>

                <Grid xs={4} sm={6}>
                  {otherDetails?.invoiceNumber && (
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: { xs: "10px", sm: "12px", md: "14px" },
                        textAlign: "right",
                      }}
                    >
                      Invoice no: {otherDetails.invoiceNumber}
                    </Typography>
                  )}

                  {otherDetails?.date && (
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: { xs: "10px", sm: "12px", md: "14px" },
                        textAlign: "right",
                      }}
                    >
                      Date:{" "}
                      {new Date(otherDetails.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </Typography>
                  )}
                  {otherDetails?.date && (
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: { xs: "10px", sm: "12px", md: "14px" },
                        textAlign: "right",
                      }}
                    >
                      Time : {new Date(otherDetails.date).toLocaleTimeString()}
                    </Typography>
                  )}
                  {otherDetails?.newDate ? (
                    <>
                      {" "}
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: { xs: "10px", sm: "12px", md: "14px" },
                          textAlign: "right",
                        }}
                      >
                        Edit Date:{" "}
                        {otherDetails?.newDate
                          ? new Date(otherDetails?.newDate).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              }
                            )
                          : ""}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: { xs: "10px", sm: "12px", md: "14px" },
                          textAlign: "right",
                        }}
                      >
                        Edit Time :{" "}
                        {otherDetails?.newDate
                          ? new Date(otherDetails?.newDate).toLocaleTimeString()
                          : ""}
                      </Typography>
                    </>
                  ) : (
                    <></>
                  )}
                  {otherDetails.returnInvoiceRef &&
                    otherDetails?.returnInvoiceRef?.length > 0 && (
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: { xs: "10px", sm: "12px", md: "14px" },
                          textAlign: "right",
                        }}
                      >
                        Invoice Ref #:{" "}
                        {Array?.isArray(otherDetails?.returnInvoiceRef)
                          ? otherDetails?.returnInvoiceRef?.map((e) => e + ",")
                          : otherDetails?.returnInvoiceRef}
                      </Typography>
                    )}

                  {otherDetails?.paymentMethod && (
                    <Typography
                      sx={{
                        color:
                          Array.isArray(otherDetails?.paymentMethod) &&
                          otherDetails?.paymentMethod?.some(
                            (e) => e.toLowerCase() == "credit"
                          )
                            ? Colors.red
                            : Colors.green,
                        fontFamily: "Poppins",
                        fontSize: { xs: "10px", sm: "12px", md: "14px" },
                        textAlign: "right",
                      }}
                    >
                      Payment Method :{" "}
                      {otherDetails?.invoiceNumber?.split("_")?.[0] == "E"
                        ? "Extra Cash Paid"
                        : Array.isArray(otherDetails.paymentMethod)
                        ? otherDetails?.paymentMethod
                            ?.map((e, i) => e)
                            .join(",")
                        : otherDetails?.paymentMethod}
                    </Typography>
                  )}

                  {otherDetails?.status && (
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: { xs: "10px", sm: "12px", md: "14px" },
                        textAlign: "right",
                      }}
                    >
                      Status : {otherDetails?.status}
                    </Typography>
                  )}

                  {otherDetails?.reason && (
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: { xs: "10px", sm: "12px", md: "14px" },
                        textAlign: "right",
                        color: Colors.red,
                        fontWeight: "bold",
                      }}
                    >
                      Reason : {otherDetails?.reason}
                    </Typography>
                  )}

                  {Array.isArray(otherDetails?.paymentMethod) &&
                    otherDetails?.paymentMethod?.some(
                      (e, i) => e.toLowerCase() == "cheque"
                    ) &&
                    !otherDetails.saleReturnDate && (
                      <Box>
                        {" "}
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            textAlign: "right",
                          }}
                        >
                          Cheque No : {otherDetails?.cheque_no}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            textAlign: "right",
                          }}
                        >
                          Bank Name : {otherDetails?.bank_name}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            textAlign: "right",
                          }}
                        >
                          Cheque Date :{" "}
                          {new Date(
                            otherDetails?.clear_date
                          )?.toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          })}
                        </Typography>
                      </Box>
                    )}

                  {Array.isArray(otherDetails?.paymentMethod) &&
                    otherDetails?.paymentMethod?.some(
                      (e, i) => e.toLowerCase() == "card"
                    ) && (
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: { xs: "10px", sm: "12px", md: "14px" },
                          textAlign: "right",
                        }}
                      >
                        Transaction Id : {otherDetails?.transactionId}
                      </Typography>
                    )}
                </Grid>

                <Button
                  onClick={() => emailInvoice()}
                  sx={{
                    backgroundColor: Colors.button,
                    color: Colors.white,
                    border: `1px solid ${Colors.button}`,
                    borderRadius: "10px",
                    width: "150px",
                    fontFamily: "Poppins",
                    "&:hover": {
                      color: Colors.button, // Set your desired hover color
                    },
                    ...buttonStyle2,
                  }}
                >
                  {loading ? (
                    <RingLoader size={30} loading={loading} />
                  ) : buttonText ? (
                    buttonText
                  ) : (
                    "Email"
                  )}
                </Button>

                {/* <Grid container xs={12} sx={{ marginTop: 2 }}>
                <Grid xs={6}>
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: {
                        xs: "10px",
                        sm: "12px",
                        md: "14px",
                        lg: "16px",
                      },
                      fontWeight: "bold",
                      borderBottom: `1px solid ${Colors.border}`,
                      marginBottom: 2,
                    }}
                  >
                    Description
                  </Typography>

                  {otherDetails?.productDetails?.map((e, i) => {
                    return (
                      <View style={{height:50}}>
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                              lg: "14px",
                            },
                            fontWeight: "400",
                            height:e?.IMEI?50:30,
                            // backgroundColor:"#e6e6e6",
                            padding:0.5,
                            margin:0.2
                          }}
                        >
                          {e.product_name}
                          <br/>
                          {typeof e?.IMEI == "object" ? (
                    <View>
                      {e?.IMEI?.map((it, ind) => {
                        return (
                          <View>
                            <Text
                              style={{
                                fontFamily: "Poppins",
                                fontSize: 12,
                              }}
                            >
                              {it},{" "}
                            </Text>
                          </View>
                        );
                      })}
                    </View>
                  ) : (
                    <Text style={{ fontFamily: "Poppins", fontSize: 12 }}>
                      {e?.IMEI}
                    </Text>
                  )}
                        </Typography>
                       
                      </View>
                    );
                  })}

                  {otherDetails?.returnProductDetails &&
                    otherDetails?.returnProductDetails?.length > 0 &&
                    otherDetails?.returnProductDetails.map((e, i) => {
                      return (
                        <View style={{height:50}}>
                          <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                              lg: "14px",
                            },
                            fontWeight: "400",
                            height:e?.IMEI?50:30,
                            // backgroundColor:"#e6e6e6",
                            padding:0.5,
                            margin:0.2
                          }}
                        >
                          {e.product_name}
                          <br/>
                          {typeof e?.IMEI == "object" ? (
                    <View>
                      {e?.IMEI?.map((it, ind) => {
                        return (
                          <View>
                            <Text
                              style={{
                                fontFamily: "Poppins",
                                fontSize: 12,
                              }}
                            >
                              {it},{" "}
                            </Text>
                          </View>
                        );
                      })}
                    </View>
                  ) : (
                    <Text style={{ fontFamily: "Poppins", fontSize: 12 }}>
                      {e?.IMEI}
                    </Text>
                  )}
                          
                        </Typography>
                       
                        </View>
                      );
                    })}
                </Grid>

                <Grid xs={1}>
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: {
                        xs: "10px",
                        sm: "12px",
                        md: "14px",
                        lg: "16px",
                      },
                      fontWeight: "bold",
                      borderBottom: `1px solid ${Colors.border}`,
                      marginBottom: 2,
                    }}
                  >
                    Quantity
                  </Typography>

                  {otherDetails?.productDetails?.map((e, i) => {
                    return (
                      <Typography

                        sx={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "14px",
                          },
                          fontWeight: "400",
                          height:e?.IMEI?50:30,
                          // backgroundColor:"#e6e6e6",
                          padding:0.5,
                          margin:0.2
                        }}
                      >
                        {(otherDetails?.transactionType?.toLowerCase() ==
                          "return invoice" ||
                          otherDetails?.transactionType?.toLowerCase() ==
                            "return quotation") &&
                          "-"}{" "}
                        {e.DamageQty ? e.DamageQty : e.saleQty}
                      </Typography>
                    );
                  })}

                  {otherDetails?.returnProductDetails &&
                    otherDetails?.returnProductDetails?.length > 0 &&
                    otherDetails.returnProductDetails.map((e, i) => {
                      return (
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                              lg: "14px",
                            },
                            fontWeight: "400",
                            height:e?.IMEI?50:30,
                            // backgroundColor:"#e6e6e6",
                            padding:0.5,
                            margin:0.2
                          }}
                        >
                          -{e.DamageQty ? e.DamageQty : e.saleQty}
                        </Typography>
                      );
                    })}
                </Grid>

                <Grid xs={1}>
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: {
                        xs: "10px",
                        sm: "12px",
                        md: "14px",
                        lg: "16px",
                      },
                      fontWeight: "bold",
                      borderBottom: `1px solid ${Colors.border}`,
                      marginBottom: 2,
                    }}
                  >
                    Price
                  </Typography>

                  {otherDetails?.productDetails?.map((e, i) => {
                    return (
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "14px",
                          },
                          fontWeight: "400",
                          height:e?.IMEI?50:30,
                          // backgroundColor:"#e6e6e6",
                          padding:0.5,
                          margin:0.2
                        }}
                      >
                        £
                        {(otherDetails?.transactionType?.toLowerCase() ==
                          "return invoice" ||
                          otherDetails?.transactionType?.toLowerCase() ==
                            "return quotation") &&
                          "-"}
                        {otherDetails?.saleReturnDate && "-"}
                        {e?.discountPrice >
                        (otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                          ? e?.trade_price
                          : otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            2
                          ? e?.warehouse_price
                          : e?.retail_price)
                          ? e?.discountPrice
                          : otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            1
                          ? Number(e.trade_price).toFixed(2)
                          : otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            2
                          ? Number(e.warehouse_price).toFixed(2)
                          : Number(e.retail_price).toFixed(2)}
                      </Typography>
                    );
                  })}

                  {otherDetails?.returnProductDetails &&
                    otherDetails?.returnProductDetails?.length > 0 &&
                    otherDetails.returnProductDetails.map((e, i) => {
                      return (
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                              lg: "14px",
                            },
                            fontWeight: "400",
                            height:e?.IMEI?50:30,
                            // backgroundColor:"#e6e6e6",
                            padding:0.5,
                            margin:0.2
                          }}
                        >
                          £-
                          {otherDetails?.customerDetails?.accountManager == "A"
                            ? Number(e?.trade_price).toFixed(2)
                            : otherDetails?.customerDetails?.accountManager ==
                              "B"
                            ? Number(e?.warehouse_price).toFixed(2)
                            : Number(e?.retail_price).toFixed(2)}
                        </Typography>
                      );
                    })}
                </Grid>

                {!(
                  otherDetails?.transactionType?.toLowerCase() ==
                    "return invoice" ||
                  otherDetails?.transactionType?.toLowerCase() ==
                    "return quotation"
                ) && (
                  <Grid xs={1}>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: {
                          xs: "10px",
                          sm: "12px",
                          md: "14px",
                          lg: "16px",
                        },
                        fontWeight: "bold",
                        borderBottom: `1px solid ${Colors.border}`,
                        marginBottom: 2,
                      }}
                    >
                      Discount
                    </Typography>

                    {otherDetails?.productDetails?.map((e, i) => {
                      return (
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                              lg: "14px",
                            },
                            fontWeight: "400",
                            height:e?.IMEI?50:30,
                            // backgroundColor:"#e6e6e6",
                            padding:0.5,
                            margin:0.2
                          }}
                        >
                          £
                          {(otherDetails?.transactionType?.toLowerCase() ==
                            "return invoice" ||
                            otherDetails?.transactionType?.toLowerCase() ==
                              "return quotation") &&
                            "-"}
                          {e.discountPrice <
                          (otherDetails?.customerDetails?.priceLevel[0]?.id == 1
                            ? e?.trade_price
                            : otherDetails?.customerDetails?.priceLevel[0]
                                ?.id == 2
                            ? e?.warehouse_price
                            : e?.retail_price)
                            ? Number(
                                (otherDetails?.customerDetails?.priceLevel[0]
                                  ?.id == 1
                                  ? e.trade_price
                                  : otherDetails?.customerDetails?.priceLevel[0]
                                      ?.id == 2
                                  ? e.warehouse_price
                                  : e.retail_price) - e.discountPrice
                              ).toFixed(2)
                            : 0}
                        </Typography>
                      );
                    })}

                    {otherDetails?.returnProductDetails &&
                      otherDetails?.returnProductDetails?.length > 0 &&
                      otherDetails.returnProductDetails.map((e, i) => {
                        return (
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: {
                                xs: "10px",
                                sm: "12px",
                                md: "14px",
                                lg: "14px",
                              },
                              fontWeight: "400",
                              height:e?.IMEI?50:30,
                              // backgroundColor:"#e6e6e6",
                              padding:0.5,
                              margin:0.2
                            }}
                          >
                            £
                            {Number(
                              e?.discountPrice
                                ? (otherDetails?.customerDetails
                                    ?.accountManager == "A"
                                    ? e?.trade_price
                                    : otherDetails?.customerDetails
                                        ?.accountManager == "B"
                                    ? e?.warehouse_price
                                    : e?.retail_price) - e?.discountPrice
                                : 0
                            ).toFixed(2)}
                          </Typography>
                        );
                      })}
                  </Grid>
                )}

                <Grid xs={2}>
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: {
                        xs: "10px",
                        sm: "12px",
                        md: "14px",
                        lg: "16px",
                      },
                      fontWeight: "bold",
                      borderBottom: `1px solid ${Colors.border}`,
                      marginBottom: 2,
                    }}
                  >
                    Amount
                  </Typography>

                  {otherDetails?.productDetails?.map((e, i) => {
                    return (
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "14px",
                          },
                          fontWeight: "400",
                          height:e?.IMEI?50:30,
                          // backgroundColor:"#e6e6e6",
                          padding:0.5,
                          margin:0.2
                        }}
                      >
                        £
                        {(otherDetails?.transactionType?.toLowerCase() ==
                          "return invoice" ||
                          otherDetails?.transactionType?.toLowerCase() ==
                            "return quotation") &&
                          "-"}
                        {Number(
                          e?.discountPrice
                            ? e?.discountPrice *
                                (e.DamageQty ? e.DamageQty : e.saleQty).toFixed(
                                  2
                                )
                            : (otherDetails?.customerDetails?.accountManager ==
                              "A"
                                ? e?.trade_price
                                : otherDetails?.customerDetails
                                    ?.accountManager == "B"
                                ? e?.warehouse_price
                                : e?.retail_price) *
                                (e.DamageQty ? e.DamageQty : e.saleQty)
                        ).toFixed(2)}
                      </Typography>
                    );
                  })}

                  {otherDetails?.returnProductDetails &&
                    otherDetails?.returnProductDetails?.length > 0 &&
                    otherDetails.returnProductDetails.map((e, i) => {
                      return (
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                              lg: "14px",
                            },
                            fontWeight: "400",
                            height:e?.IMEI?50:30,
                            // backgroundColor:"#e6e6e6",
                            padding:0.5,
                            margin:0.2
                          }}
                        >
                          £-
                          {Number(
                            e?.discountPrice
                              ? e?.discountPrice *
                                  (e.DamageQty
                                    ? e.DamageQty
                                    : e.saleQty
                                  ).toFixed(2)
                              : (otherDetails?.customerDetails
                                  ?.accountManager == "A"
                                  ? e?.trade_price
                                  : otherDetails?.customerDetails
                                      ?.accountManager == "B"
                                  ? e?.warehouse_price
                                  : e?.retail_price) *
                                  (e.DamageQty ? e.DamageQty : e.saleQty)
                          ).toFixed(2)}
                        </Typography>
                      );
                    })}
                </Grid>
              </Grid> */}
                <Table sx={{ marginTop: 2 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{ width: showDiscount ? "60%" : "65%" }}
                      >
                        <strong>Description</strong>
                      </TableCell>
                      <TableCell style={{ width: "10%" }}>
                        <strong>Quantity</strong>
                      </TableCell>
                      <TableCell style={{ width: "10%" }}>
                        <strong>Price</strong>
                      </TableCell>
                      {showDiscount &&
                        ![
                          "return invoice",
                          "return quotation",
                          "exchange quotation",
                        ].includes(
                          otherDetails?.transactionType?.toLowerCase()
                        ) && (
                          <TableCell style={{ width: "10%" }}>
                            <strong>Discount</strong>
                          </TableCell>
                        )}
                      <TableCell style={{ width: "10%" }}>
                        <strong>Amount</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {[
                      ...(otherDetails?.productDetails || []),
                      
                    ].map((e, i) => {
                      const isReturn =
                        otherDetails?.returnProductDetails?.includes(e);
                      const isReturnType = [
                        "return invoice",
                        "return quotation",
                        "exchange quotation",
                      ].includes(otherDetails?.transactionType?.toLowerCase());
                      const isReturnType2 = [
                        "return invoice",
                        "return quotation",
                      ].includes(otherDetails?.transactionType?.toLowerCase());

                      const getPrice = () => {
                        const priceLevel =
                          otherDetails?.customerDetails?.priceLevel[0]?.id;
                        if (
                          e?.discountPrice >
                          (priceLevel === 1
                            ? e?.trade_price
                            : priceLevel === 2
                            ? e?.warehouse_price
                            : e?.retail_price)
                        ) {
                          return e.discountPrice;
                        }
                        return priceLevel === 1
                          ? e.trade_price
                          : priceLevel === 2
                          ? e.warehouse_price
                          : e.retail_price;
                      };

                      const getDiscount = () => {
                       {return (e.discountPrice
                        ? Number(
                            (otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            1
                              ? e.trade_price
                              :otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            4
                              ? e.diamond
                              : 
                              otherDetails?.customerDetails?.priceLevel[0]
                                  ?.id == 2
                              ? e.warehouse_price
                              : e.retail_price) - e.discountPrice
                          ).toFixed(2)
                        : 0)}
                      };
                      

                      const getAmount = () => {
                        const quantity = e.DamageQty || e.saleQty || 0;
                        const unitPrice = e?.discountPrice || getPrice();
                        return (unitPrice * quantity).toFixed(2);
                      };
                      const getPriceWithoutQty = () => {
                        const unitPrice = e?.discountPrice || getPrice();
                        return unitPrice;
                      };

                      const priceSign = isReturn
                        ? "-"
                        : isReturnType2
                        ? "-"
                        : "";
                      const discountSign = isReturn ? "-" : "";

                      return (
                        <TableRow key={i}>
                          <TableCell
                            style={{ width: showDiscount ? "60%" : "65%" }}
                          >
                            {e.productName}
                            <br />
                            {Array.isArray(e?.IMEI) ? (
                              e?.IMEI.map((it, ind) => (
                                <Typography
                                  key={ind}
                                  sx={{ fontSize: 12, fontFamily: "Poppins" }}
                                >
                                  {it}
                                </Typography>
                              ))
                            ) : (
                              <Typography
                                sx={{ fontSize: 12, fontFamily: "Poppins" }}
                              >
                                {e?.IMEI}
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell style={{ width: "10%" }}>
                            {isReturn || isReturnType2 ? "-" : ""}
                            {e.DamageQty ? e.DamageQty : e.saleQty}
                          </TableCell>

                          <TableCell style={{ width: "10%" }}>
                            £{priceSign}
                            {showDiscount
                              ? Number(getPrice()).toFixed(2)
                              : getPriceWithoutQty()}
                          </TableCell>

                          {showDiscount && !isReturnType && (
                            <TableCell style={{ width: "10%" }}>
                              £{discountSign}
                              {getDiscount()}
                            </TableCell>
                          )}

                          <TableCell style={{ width: "10%" }}>
                            £{isReturn || isReturnType2 ? "-" : ""}
                            {getAmount()}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {/* {(otherDetails?.returnProductDetails)?((otherDetails?.SDAmount||otherDetails?.vatAmount) ?<></>:([
                     ...(otherDetails?.returnProductDetails || []),
                      
                    ].map((e, i) => {
                      const isReturn =
                        otherDetails?.returnProductDetails?.includes(e);
                      const isReturnType = [
                        "return invoice",
                        "return quotation",
                        "exchange quotation",
                      ].includes(otherDetails?.transactionType?.toLowerCase());
                      const isReturnType2 = [
                        "return invoice",
                        "return quotation",
                      ].includes(otherDetails?.transactionType?.toLowerCase());

                      const getPrice = () => {
                        const priceLevel =
                          otherDetails?.customerDetails?.priceLevel[0]?.id;
                        if (
                          e?.discountPrice >
                          (priceLevel === 1
                            ? e?.trade_price
                            : priceLevel === 2
                            ? e?.warehouse_price
                            : e?.retail_price)
                        ) {
                          return e.discountPrice;
                        }
                        return priceLevel === 1
                          ? e.trade_price
                          : priceLevel === 2
                          ? e.warehouse_price
                          : e.retail_price;
                      };

                      const getDiscount = () => {
                       {return (e.discountPrice
                        ? Number(
                            (otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            1
                              ? e.trade_price
                              :otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            4
                              ? e.diamond
                              : 
                              otherDetails?.customerDetails?.priceLevel[0]
                                  ?.id == 2
                              ? e.warehouse_price
                              : e.retail_price) - e.discountPrice
                          ).toFixed(2)
                        : 0)}
                      };
                      

                      const getAmount = () => {
                        const quantity = e.DamageQty || e.saleQty || 0;
                        const unitPrice = e?.discountPrice || getPrice();
                        return (unitPrice * quantity).toFixed(2);
                      };
                      const getPriceWithoutQty = () => {
                        const unitPrice = e?.discountPrice || getPrice();
                        return unitPrice;
                      };

                      const priceSign = isReturn
                        ? "-"
                        : isReturnType2
                        ? "-"
                        : "";
                      const discountSign = isReturn ? "-" : "";

                      return (
                        <TableRow key={i}>
                          <TableCell
                            style={{ width: showDiscount ? "60%" : "65%" }}
                          >
                            {e.productName}
                            <br />
                            {Array.isArray(e?.IMEI) ? (
                              e?.IMEI.map((it, ind) => (
                                <Typography
                                  key={ind}
                                  sx={{ fontSize: 12, fontFamily: "Poppins" }}
                                >
                                  {it}
                                </Typography>
                              ))
                            ) : (
                              <Typography
                                sx={{ fontSize: 12, fontFamily: "Poppins" }}
                              >
                                {e?.IMEI}
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell style={{ width: "10%" }}>
                            {isReturn || isReturnType2 ? "-" : ""}
                            {e.DamageQty ? e.DamageQty : e.saleQty}
                          </TableCell>

                          <TableCell style={{ width: "10%" }}>
                            £{priceSign}
                            {showDiscount
                              ? Number(getPrice()).toFixed(2)
                              : getPriceWithoutQty()}
                          </TableCell>

                          {showDiscount && !isReturnType && (
                            <TableCell style={{ width: "10%" }}>
                              £{discountSign}
                              {getDiscount()}
                            </TableCell>
                          )}

                          <TableCell style={{ width: "10%" }}>
                            £{isReturn || isReturnType2 ? "-" : ""}
                            {getAmount()}
                          </TableCell>
                        </TableRow>
                      );
                    }))):<></>} */}
                  </TableBody>
                </Table>
                {/* <div container xs={12} style={{ marginTop: 15,display:"flex" }} >

              <div style={{width:"52%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderTop: `1px solid ${Colors.border}`, marginBottom: 2 }} >

                  Subtotal

                </Typography>


              </div>

              <div xs={1} style={{width:"12%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderTop: `1px solid ${Colors.border}`, marginBottom: 2 }} >
{otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''}
                  {otherDetails?.productDetails&&otherDetails?.productDetails.reduce((a,b)=>{
                    return otherDetails?.saleReturnDate?b?.DamageQty?a+b?.DamageQty:a+b?.saleQty:a+b?.saleQty
                  },0)}

                </Typography>


              </div>

              <div xs={1} style={{width:"12%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderTop: `1px solid ${Colors.border}`, marginBottom: 2 }} >


                </Typography>


              </div>




             { <div xs={1} style={{width:"12%"}} >



               {(otherDetails?.paymentMethod!="Credit Note"&&showDiscount)&& <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderTop: `1px solid ${Colors.border}`, marginBottom: 2 }} >

                  £{otherDetails.discount ? Number(otherDetails.discount).toFixed(2) : 0}

                </Typography>}


              </div>}

              <div xs={2} style={{width:"12%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderTop: `1px solid ${Colors.border}`, marginBottom: 2 }} >
£{ otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''}
                  {Number(otherDetails.total - (otherDetails?.discount || 0)).toFixed(2)}

                </Typography>


              </div>



            </div> */}
                <div
                  container
                  xs={12}
                  sx={{ marginTop: 2 }}
                  style={{ marginTop: 15, display: "flex" }}
                >
                  <div
                    xs={6}
                    style={{
                      width: showDiscount
                        ? otherDetails?.transactionType?.toLowerCase() ==
                            "return invoice" ||
                          otherDetails?.transactionType?.toLowerCase() ==
                            "return quotation" ||
                          otherDetails?.transactionType?.toLowerCase() ==
                            "exchange quotation"
                          ? "68%"
                          : "65%"
                        : "70%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: {
                          xs: "10px",
                          sm: "12px",
                          md: "14px",
                          lg: "16px",
                        },
                        fontWeight: "bold",
                        borderTop: `1px solid ${Colors.border}`,
                        marginBottom: 2,
                      }}
                    >
                      {otherDetails?.returnProductDetails?.length != 0
                        ? "Sale "
                        : ""}{" "}
                      {"Subtotal"}
                    </Typography>
                  </div>

                  <div xs={1} style={{ width: "10%" }}>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: {
                          xs: "10px",
                          sm: "12px",
                          md: "14px",
                          lg: "16px",
                        },
                        fontWeight: "bold",
                        borderTop: `1px solid ${Colors.border}`,
                        marginBottom: 2,
                      }}
                    >
                      {(otherDetails?.transactionType?.toLowerCase() ==
                        "return invoice" ||
                        otherDetails?.transactionType?.toLowerCase() ==
                          "return quotation") &&
                        "-"}{" "}
                      {otherDetails?.productDetails &&
                        otherDetails?.productDetails.reduce((a, b) => {
                          return otherDetails?.transactionType?.toLowerCase() ==
                            "return invoice" ||
                            otherDetails?.transactionType?.toLowerCase() ==
                              "return quotation"
                            ? b?.DamageQty
                              ? a + b?.DamageQty
                              : a + b?.saleQty
                            : a + b?.saleQty;
                        }, 0)}
                    </Typography>
                  </div>

                  <div xs={1} style={{ width: "10%" }}>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: {
                          xs: "10px",
                          sm: "12px",
                          md: "14px",
                          lg: "16px",
                        },
                        fontWeight: "bold",
                        borderTop: `1px solid ${Colors.border}`,
                        marginBottom: 2,
                      }}
                    ></Typography>
                  </div>

                  {showDiscount &&
                    !(
                      otherDetails?.transactionType?.toLowerCase() ==
                        "return invoice" ||
                      otherDetails?.transactionType?.toLowerCase() ==
                        "return quotation" ||
                      otherDetails?.transactionType?.toLowerCase() ==
                        "exchange quotation"
                    ) && (
                      <div xs={1} style={{ width: "10%" }}>
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                              lg: "16px",
                            },
                            fontWeight: "bold",
                            borderTop: `1px solid ${Colors.border}`,
                            marginBottom: 2,
                          }}
                        >
                          £
                          {(otherDetails?.transactionType?.toLowerCase() ==
                            "return invoice" ||
                            otherDetails?.transactionType?.toLowerCase() ==
                              "return quotation") &&
                            "-"}
                          {otherDetails.discount
                            ? Number(otherDetails.discount).toFixed(2)
                            : 0}
                        </Typography>
                      </div>
                    )}

                  <div xs={2} style={{ width: "10%" }}>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: {
                          xs: "10px",
                          sm: "12px",
                          md: "14px",
                          lg: "16px",
                        },
                        fontWeight: "bold",
                        borderTop: `1px solid ${Colors.border}`,
                        marginBottom: 2,
                      }}
                    >
                      £{" "}
                      {(otherDetails?.transactionType?.toLowerCase() ==
                        "return invoice" ||
                        otherDetails?.transactionType?.toLowerCase() ==
                          "return quotation" ||
                        otherDetails?.invoiceNumber?.split("_")?.[0] == "E") &&
                        "-"}
                      {otherDetails?.invoiceNumber?.split("_")?.[0] == "E"
                        ? Number(otherDetails?.total).toFixed(2)
                        : Number(
                            otherDetails?.vatAmount
                              ? otherDetails?.total -
                                  (otherDetails?.discount || 0)
                              : otherDetails.total -
                                  (otherDetails?.discount || 0)
                          ).toFixed(2)}
                    </Typography>
                  </div>
                </div>
                {otherDetails?.SDAmount != 0 &&
                  otherDetails?.SDAmount != null &&
                  otherDetails?.SDAmount != undefined && (
                    <div
                      container
                      xs={12}
                      style={{
                        paddingTop: 5,
                        margin: "10px 0",
                        display: "flex",
                        borderTop: `solid ${Colors.border} 1px`,
                      }}
                    >
                      {/* <View
                // key={index}
                style={{
                  flexDirection: "row",
                  // borderWidth: 1,
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderColor: "#000",
                  borderTopWidth: 1,
                  padding: "5px 10px",
                }}
              > */}
                      <div xs={10} style={{ width: "90%" }}>
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                              lg: "16px",
                            },
                            fontWeight: "bold",
                          }}
                        >
                          Special Discount{" "}
                          {(
                            (otherDetails?.SDAmount /
                              (otherDetails?.total -
                                // +
                                // (otherDetails?.vatAmount || 0)
                                (otherDetails?.discount || 0))) *
                            100
                          ).toFixed(2)}
                          %
                        </Text>
                      </div>

                      <div xs={2} style={{ width: "10%" }}>
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                              lg: "16px",
                            },
                            fontWeight: "bold",
                          }}
                        >
                          - £ {otherDetails?.saleReturnDate && "-"}
                          {Number(otherDetails?.SDAmount).toFixed(2)}
                          {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                        </Text>
                      </div>
                      {/* </View> */}
                    </div>
                  )}

                {otherDetails?.vatAmount && otherDetails?.SDAmount ? (
                  <div
                    container
                    xs={12}
                    style={{
                      paddingTop: 5,
                      margin: "10px 0",
                      display: "flex",
                      borderTop: `solid ${Colors.border} 1px`,
                    }}
                  >
                    {/* <View
                // key={index}
                style={{
                  flexDirection: "row",
                  // borderWidth: 1,
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderColor: "#000",
                  borderTopWidth: 1,
                  padding: "5px 10px",
                }}
              > */}
                    <div xs={10} style={{ width: "90%" }}>
                      <Text
                        style={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                        }}
                      >
                        Subtotal
                      </Text>
                    </div>

                    <div xs={2} style={{ width: "10%" }}>
                      <Text
                        style={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                        }}
                      >
                        £{" "}
                        {(
                          Number(otherDetails?.total) -
                          Number(otherDetails?.discount) -
                          Number(otherDetails?.SDAmount)
                        ).toFixed(2)}
                        {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                      </Text>
                    </div>
                    {/* </View> */}
                  </div>
                ) : (
                  ""
                )}
                {otherDetails.vatAmount ? (
                  <div
                    container
                    xs={12}
                    style={{
                      marginTop: 10,
                      display: "flex",
                      borderTop: `1px solid ${Colors.border}`,
                      padding: 5,
                    }}
                  >
                    <div item xs={9} style={{ width: "95%" }}>
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                          marginBottom: 2,
                        }}
                      >
                        VAT
                      </Typography>
                    </div>

                    <div item xs={2} style={{ width: "10%" }}>
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                          marginBottom: 2,
                        }}
                      >
                        £
                        {(otherDetails?.transactionType?.toLowerCase() ==
                          "return invoice" ||
                          otherDetails?.transactionType?.toLowerCase() ==
                            "return quotation") &&
                          "-"}
                        {Number(otherDetails?.vatAmount).toFixed(2)}
                      </Typography>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {(otherDetails?.returnProductDetails&&(otherDetails?.vatAmount||otherDetails?.SDAmount)) ? (
                  <div
                    container
                    xs={12}
                    style={{
                      marginTop: 10,
                      display: "flex",
                      borderTop: `1px solid ${Colors.border}`,
                      padding: 5,
                    }}
                  >
                    <div item xs={9} style={{ width: "95%" }}>
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                          marginBottom: 2,
                        }}
                      >
                        Total
                      </Typography>
                    </div>

                    <div item xs={2} style={{ width: "10%" }}>
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                          marginBottom: 2,
                        }}
                      >
                        £
                        {(Number(otherDetails.vatAmount||0)+(Number((otherDetails.total||0) - (otherDetails?.discount || 0)))-Number(otherDetails?.SDAmount||0)).toFixed(2)}
                      </Typography>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {((otherDetails?.returnProductDetails)&&otherDetails?.returnProductDetails?.length != 0) ? (
                 <>
                 <Table>
                  <TableBody>
                    {([
                     ...(otherDetails?.returnProductDetails || []),
                      
                    ].map((e, i) => {
                      const isReturn =
                        otherDetails?.returnProductDetails?.includes(e);
                      const isReturnType = [
                        "return invoice",
                        "return quotation",
                        "exchange quotation",
                      ].includes(otherDetails?.transactionType?.toLowerCase());
                      const isReturnType2 = [
                        "return invoice",
                        "return quotation",
                      ].includes(otherDetails?.transactionType?.toLowerCase());

                      const getPrice = () => {
                        const priceLevel =
                          otherDetails?.customerDetails?.priceLevel[0]?.id;
                        if (
                          e?.discountPrice >
                          (priceLevel === 1
                            ? e?.trade_price
                            : priceLevel === 2
                            ? e?.warehouse_price
                            : e?.retail_price)
                        ) {
                          return e.discountPrice;
                        }
                        return priceLevel === 1
                          ? e.trade_price
                          : priceLevel === 2
                          ? e.warehouse_price
                          : e.retail_price;
                      };

                      const getDiscount = () => {
                       {return (e.discountPrice
                        ? Number(
                            (otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            1
                              ? e.trade_price
                              :otherDetails?.customerDetails?.priceLevel[0]?.id ==
                            4
                              ? e.diamond
                              : 
                              otherDetails?.customerDetails?.priceLevel[0]
                                  ?.id == 2
                              ? e.warehouse_price
                              : e.retail_price) - e.discountPrice
                          ).toFixed(2)
                        : 0)}
                      };
                      

                      const getAmount = () => {
                        const quantity = e.DamageQty || e.saleQty || 0;
                        const unitPrice = e?.discountPrice || getPrice();
                        return (unitPrice * quantity).toFixed(2);
                      };
                      const getPriceWithoutQty = () => {
                        const unitPrice = e?.discountPrice || getPrice();
                        return unitPrice;
                      };

                      const priceSign = isReturn
                        ? "-"
                        : isReturnType2
                        ? "-"
                        : "";
                      const discountSign = isReturn ? "-" : "";

                      return (
                        <TableRow key={i}>
                          <TableCell
                            style={{ width: showDiscount ? "60%" : "65%" }}
                          >
                            {e.productName}
                            <br />
                            {Array.isArray(e?.IMEI) ? (
                              e?.IMEI.map((it, ind) => (
                                <Typography
                                  key={ind}
                                  sx={{ fontSize: 12, fontFamily: "Poppins" }}
                                >
                                  {it}
                                </Typography>
                              ))
                            ) : (
                              <Typography
                                sx={{ fontSize: 12, fontFamily: "Poppins" }}
                              >
                                {e?.IMEI}
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell style={{ width: "10%" }}>
                            {isReturn || isReturnType2 ? "-" : ""}
                            {e.DamageQty ? e.DamageQty : e.saleQty}
                          </TableCell>

                          <TableCell style={{ width: "10%" }}>
                            £{priceSign}
                            {showDiscount
                              ? Number(getPrice()).toFixed(2)
                              : getPriceWithoutQty()}
                          </TableCell>

                          {showDiscount && !isReturnType && (
                            <TableCell style={{ width: "10%" }}>
                              £{discountSign}
                              {getDiscount()}
                            </TableCell>
                          )}

                          <TableCell style={{ width: "10%" }}>
                            £{isReturn || isReturnType2 ? "-" : ""}
                            {getAmount()}
                          </TableCell>
                        </TableRow>
                      );
                    }))}
                  </TableBody>
                 </Table>
                 {otherDetails?.returnSd != 0 &&
                  otherDetails?.returnSd != null &&
                  otherDetails?.returnSd != undefined && (
                    <div
                      container
                      xs={12}
                      style={{
                        paddingTop: 5,
                        margin: "10px 0",
                        display: "flex",
                        borderTop: `solid ${Colors.border} 1px`,
                      }}
                    >
                      <div xs={10} style={{ width: "90%" }}>
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                              lg: "16px",
                            },
                            fontWeight: "bold",
                          }}
                        >
                          Special Discount
                        </Text>
                      </div>

                      <div xs={2} style={{ width: "10%" }}>
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: {
                              xs: "10px",
                              sm: "12px",
                              md: "14px",
                              lg: "16px",
                            },
                            fontWeight: "bold",
                          }}
                        >
                          - £
                          {Number(otherDetails?.returnSd).toFixed(2)}
                          {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                        </Text>
                      </div>
                      {/* </View> */}
                    </div>
                  )}
                   {otherDetails.returnVat ? (
                  <div
                    container
                    xs={12}
                    style={{
                      marginTop: 10,
                      display: "flex",
                      borderTop: `1px solid ${Colors.border}`,
                      padding: 5,
                    }}
                  >
                    <div item xs={9} style={{ width: "95%" }}>
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                          marginBottom: 2,
                        }}
                      >
                        VAT
                      </Typography>
                    </div>

                    <div item xs={2} style={{ width: "10%" }}>
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                          marginBottom: 2,
                        }}
                      >
                        -£
                        {Number(otherDetails?.returnVat).toFixed(2)}
                      </Typography>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                 <div
                    container
                    xs={12}
                    style={{
                      paddingTop: 5,
                      margin: "10px 0",
                      display: "flex",
                      borderTop: `solid ${Colors.border} 1px`,
                    }}
                  >
                    {/* <View
                              // key={index}
                              style={{
                                flexDirection: "row",
                                // borderWidth: 1,
                                borderLeftWidth: 1,
                                borderRightWidth: 1,
                                borderColor: "#000",
                                borderTopWidth: 1,
                                padding: "5px 10px",
                              }}
                            > */}
                    <div xs={10} style={{ width: "88%" }}>
                      <Text
                        style={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                        }}
                      >
                        Return Subtotal
                      </Text>
                    </div>

                    <div xs={2} style={{ width: "12%" }}>
                      <Text
                        style={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                        }}
                      >
                        -£
                        {otherDetails?.returnProductDetails?.length != 0
                          ? (otherDetails?.returnProductDetails?.reduce(
                              (a, b) =>
                                a +
                                Number(b.rate) * (b?.DamageQty || b?.saleQty),
                              0
                            ) -
                            (otherDetails?.returnSd || 0) +
                            (otherDetails?.returnVat || 0)).toFixed(2)
                          : 0}
                        {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                      </Text>
                    </div>
                    {/* </View> */}
                  </div>
                 </>
                ):<></>}

                {
                  <div
                    container
                    xs={12}
                    style={{ marginTop: 15, display: "flex" }}
                  >
                    <div
                      item
                      xs={9}
                      sx={{ borderTop: `1px solid ${Colors.border}` }}
                      style={{
                        width: "95%",
                        borderTop: `1px solid ${Colors.border}`,
                        padding: 5,
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                          marginBottom: 2,
                          color: Colors.red,
                        }}
                      >
                        Grand Total
                      </Typography>
                    </div>

                    <div
                      item
                      xs={3}
                      sx={{}}
                      style={{
                        width: "10%",
                        borderTop: `1px solid ${Colors.border}`,
                        padding: 5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: {
                            xs: "10px",
                            sm: "12px",
                            md: "14px",
                            lg: "16px",
                          },
                          fontWeight: "bold",
                          marginBottom: 2,
                          color: Colors.red,
                        }}
                      >
                        £
                        {(otherDetails?.transactionType?.toLowerCase() ==
                  "return invoice" ||
                  otherDetails?.transactionType?.toLowerCase() ==
                    "return quotation" ||
                  otherDetails?.invoiceNumber?.split("_")?.[0] == "E") &&
                  "-"}
                {otherDetails?.invoiceNumber?.split("_")?.[0] == "E"
                  ? Number(otherDetails?.total).toFixed(2)
                  : Number(otherDetails?.subtotal).toFixed(2)}
                      </Typography>
                    </div>
                  </div>
                }
              </div>
              <Box>
                <Typography
                  style={{
                    fontSize: 15,
                    fontWeight: "500",
                    color: Colors.black,
                    fontFamily: "Poppins",
                  }}
                >
                  This invoice has been served by{" "}
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: Colors.red,
                      fontFamily: "Poppins",
                    }}
                  >
                    {otherDetails?.employeeDetails?.fullName}
                  </span>
                </Typography>
              </Box>
              {(userData?.role === "admin" ||
                userData?.role_access?.some(
                  (e, i) => e.name.toLowerCase() == "showprofit" && e?.selected
                )) && (
                <Typography
                  style={{
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                >
                  {otherDetails?.status == "Return" &&
                  otherDetails.transactionType != "Exchange Quotation" &&
                  otherDetails?.transactionType != "Exchange Invoice"
                    ? "Loss"
                    : Number(
                        //             Math.abs(otherDetails?.type!="exchange"?otherDetails?.subtotal || 0:otherDetails?.saleSubtotal
                        //  || 0)
                        //             // - (otherDetails?.discount || 0)
                        //             -

                        (otherDetails?.productDetails || []).reduce(
                          (sum, i) => {
                            const qty =
                              (i?.DamageQty ? i?.DamageQty : i?.returnQty) ||
                              i?.saleQty;

                            return sum + (i?.rate - i?.cost_price) * (qty || 0);
                          },
                          0
                        ) -
                          (otherDetails?.returnProductDetails || []).reduce(
                            (sum, i) => {
                              const qty =
                                (i?.DamageQty ? i?.DamageQty : i?.returnQty) ||
                                i?.saleQty;

                              return (
                                sum + (i?.rate - i?.cost_price) * (qty || 0)
                              );
                            },
                            0
                          ) -
                          (otherDetails?.discount || 0) -
                          ((otherDetails?.SDAmount || 0) -
                            (otherDetails?.returnSd || 0))
                      ) < 0
                    ? "Loss"
                    : "PF"}
                  :{" "}
                  {Math.abs(
                    Number(
                      //             Math.abs(otherDetails?.type!="exchange"?otherDetails?.subtotal || 0:otherDetails?.saleSubtotal
                      //  || 0)
                      //             // - (otherDetails?.discount || 0)
                      //             -

                      (otherDetails?.productDetails || []).reduce((sum, i) => {
                        const qty =
                          (i?.DamageQty ? i?.DamageQty : i?.returnQty) ||
                          i?.saleQty;

                        return sum + (i?.rate - i?.cost_price) * (qty || 0);
                      }, 0) -
                        (otherDetails?.returnProductDetails || []).reduce(
                          (sum, i) => {
                            const qty =
                              (i?.DamageQty ? i?.DamageQty : i?.returnQty) ||
                              i?.saleQty;

                            return sum + (i?.rate - i?.cost_price) * (qty || 0);
                          },
                          0
                        ) -
                        (otherDetails?.discount || 0) -
                        ((otherDetails?.SDAmount || 0) -
                          (otherDetails?.returnSd || 0))
                    )
                  ).toFixed(2)}
                </Typography>
              )}
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  ...buttonContainerStyle,
                }}
              >
                <Button
                  onClick={() => {
                    closeModal();
                    // setOtherDetails({})
                    setSelectedInvoice({});
                  }}
                  sx={{
                    backgroundColor: "#5DC002",
                    color: Colors.white,
                    border: `1px solid ${Colors.button}`,
                    borderRadius: "20px",
                    width: "200px",
                    fontSize: "14px",
                    textTransform: "capitalize",
                    mt: 1,
                    fontFamily: "Poppins",
                    "&:hover": {
                      color: "#5DC002",
                    },
                    ...buttonStyle,
                  }}
                >
                  Close
                </Button>
              </Box>
            </Box>
          </>
        )}
      </Modal>
    </div>
  );
}

export default React.forwardRef(TransactionDetailsModal);
